var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinecone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M12 2L6 8h12l-6-6zm-7 7l-2 3h18l-2-3H5zm-1 4l1 3h14l1-3H4zm2 4l2 3h8l2-3H6zm3 4l1 2h4l1-2H9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinecone);
export default __webpack_public_path__ + "static/media/pinecone.f0ab73fdb2229513772d683e71e0073d.svg";
export { ForwardRef as ReactComponent };